import { Subject } from "rxjs";

const subject = new Subject();
const jobSubject = new Subject();

export const modalService: any = {
  openModal: (member: any) => subject.next(member),
  listenModal: () => subject.asObservable()
};

export const jobModalService: any = {
  openJobModal: (id: number) => jobSubject.next(id),
  listenJobModal: () => jobSubject.asObservable()
};
